import {
  AppType,
  DeviceType
} from '@maxpreps/shared/functions/utils/requestContextUtils';
import { createContext, useContext } from 'react';
import { IChildrenProps } from '../models/utilTypes';

export interface IRequestContext {
  deviceType: DeviceType;
  appType: AppType;
}

export const DEFAULT_REQUEST_CONTEXT = {
  deviceType: DeviceType.Desktop,
  appType: AppType.None
};

const RequestContext = createContext<IRequestContext>(DEFAULT_REQUEST_CONTEXT);

RequestContext.displayName = 'RequestContext';

interface IRequestContextProviderProps extends IChildrenProps {
  requestContext: IRequestContext;
}

const RequestContextProvider: React.FC<IRequestContextProviderProps> = ({
  requestContext,
  children
}) => (
  <RequestContext.Provider value={requestContext}>
    {children}
  </RequestContext.Provider>
);
const useRequestContext = () => {
  const context = useContext(RequestContext);
  if (context === undefined) {
    throw new Error(
      'useRequestContext must be used within a RequestContextProvider'
    );
  }
  return context;
};

export { RequestContextProvider, useRequestContext as default };

